<template>
    <van-popup v-model:show="localShow" position="bottom" round z-index="9" class="bg-#01031B color-#fff">
        <div class="w-full h-60px px-20px flex items-center justify-center">
            <div class="text-center text-16px font-500 text-16px font-900">
                {{ t('scene.changeScene') }}
            </div>
        </div>

        <div class="p-20px pt-10px px-0 relative">
            <div class="scene-list-container w-full h-full rounded-10px max-h-300px px-20px" ref="sceneListRef"
                @scroll="handleScroll">
                <div v-for="(item, index) in sceneList" :key="item.id"
                    class="on-active-scene content-color relative p-4px rounded-10px mb-10px"
                    :class="{ 'active-scene': item.isSet }" @click="handleSelectScene(item, index)">
                    <div class="text-15px font-800 text-#fff pb-8px px-7px">
                        {{ t('scene.sceneIndex', { num: index + 1 }) }}
                    </div>
                    <div class="w-95% m-auto h-1px bg-#353750"></div>
                    <div class="w-full w-100% box-item-container message-content-html bg-color "
                        v-html="renderMarkdown(item.firstMes)">
                    </div>
                    <!-- <img src="@/assets/images/home/gouxuan.svg" alt=""
                        class="absolute top--1px right--1px w-16px h-16px" v-if="item.isSet"> -->
                    <div class="flex items-center justify-center absolute top-8px right-12px see_all" @click="handleShowAll(item, index)">
                        <div class="mr-2px">See all</div>
                        <!-- <img src="@/assets/images/chat/chatRecord/small.png" alt="" class=" w-5px h-6px"> -->
                    </div>
                </div>
            </div>
            <!-- 📱 自定义滚动指示器（移动端可见） -->
            <div v-if="showScrollbar" class="custom-scrollbar">
                <div class="scrollbar-thumb" :style="scrollbarStyle"></div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model:show="showScenePreview" position="center" z-index="20" class="scene-preview-popup"
        :overlay-style="{ background: 'rgba(1, 3, 27, 0.88)' }" @click="showScenePreview = false">
        <div class="scene-preview-content">
            <div class="scene-preview-title">
                Scene {{ previewSceneIndex + 1 }}
            </div>
            <div class="scene-preview-message message-content-html message-content-html-popup"
                v-html="renderMarkdown(previewScene?.firstMes || '')"></div>
            <div class="scene-preview-footer">
                <button class="scene-select-btn" @click.top="confirmSelectScene">
                    Select this scene
                </button>
                <div class="scene-close-btn">
                    <img src="@/assets/images/chat/detail/close.webp" alt="" class="w-100% h-100%">
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMarkdown } from '@/composables/useMarkdown'
import { theme } from "@/styles/theme";

const { t } = useI18n()

interface Scene {
    id: string | number
    firstMes: string
    isSet: boolean
    [key: string]: any
}

interface Props {
    show: boolean
    sceneList: Scene[]
}

const props = withDefaults(defineProps<Props>(), {
    show: false,
    sceneList: () => []
})

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
    (e: 'select', scene: Scene, index: number): void
}>()

const { renderMarkdown } = useMarkdown()

const localShow = computed({
    get: () => props.show,
    set: (value: boolean) => emit('update:show', value)
})

const handleSelectScene = (item: Scene, index: number) => {
    previewScene.value = item
    previewSceneIndex.value = index
    showScenePreview.value = true
}
const showScenePreview = ref(false)
const previewScene = ref<Scene | null>(null)
const previewSceneIndex = ref(0)
// 📱 自定义滚动指示器
const sceneListRef = ref<HTMLElement>()
const showScrollbar = ref(false)
const scrollbarStyle = ref({
    height: '0px',
    top: '0px'
})

const handleScroll = () => {
    const el = sceneListRef.value
    if (!el) return

    const { scrollTop, scrollHeight, clientHeight } = el

    // 判断是否需要显示滚动条
    showScrollbar.value = scrollHeight > clientHeight

    if (showScrollbar.value) {
        // 计算滚动条高度和位置
        const scrollbarHeight = (clientHeight / scrollHeight) * clientHeight
        const scrollbarTop = (scrollTop / scrollHeight) * clientHeight

        scrollbarStyle.value = {
            height: `${scrollbarHeight}px`,
            top: `${scrollbarTop}px`
        }
    }
}


const handleShowAll = (item: Scene, index: number) => {
    previewScene.value = item
    previewSceneIndex.value = index
    showScenePreview.value = true
}
const confirmSelectScene = () => {
    if(previewSceneIndex.value==0){
        showScenePreview.value = false
        localShow.value = false
        return
    }
    if (!previewScene.value) return
    emit('select', previewScene.value, previewSceneIndex.value)
    showScenePreview.value = false
    localShow.value = false
}

onMounted(() => {
    // 初始化时检查是否需要滚动条
    setTimeout(() => {
        handleScroll()
    }, 100)
})

onUnmounted(() => {
    showScrollbar.value = false
})
</script>

<style scoped lang="scss">
// 场景列表容器滚动条样式
.scene-list-container {
    h3 {
        font-size: 14px !important;
    }

    -webkit-overflow-scrolling: touch;
    overflow-y: scroll !important;

    // Firefox 蓝色滚动条
    // scrollbar-width: thin !important;
    // scrollbar-color: #5a68ff transparent !important;

    // // 自定义蓝色滚动条 - 移动端和桌面端都生效
    // &::-webkit-scrollbar {
    //     display: block !important;
    //     width: 6px !important;
    //     -webkit-appearance: none !important; // 禁用原生样式
    // }

    // &::-webkit-scrollbar-track {
    //     background: transparent !important;
    //     border-radius: 4px;
    //     -webkit-box-shadow: none !important;
    // }

    // &::-webkit-scrollbar-thumb {
    //     background: rgba(90, 104, 255, 0.6) !important; // 蓝色
    //     border-radius: 4px;
    //     -webkit-border-radius: 4px !important;
    //     border: none !important;

    //     &:hover {
    //         background: rgba(90, 104, 255, 0.8) !important;
    //     }

    //     &:active {
    //         background: rgba(90, 104, 255, 1) !important;
    //     }
    // }

    // 📱 移动端强制显示滚动条的额外处理
    // &::-webkit-scrollbar-button {
    //     display: none !important;
    // }
}

// 📱 自定义滚动指示器样式（移动端可见）
.custom-scrollbar {
    position: absolute;
    right: 2px;
    top: 10px;
    bottom: 10px;
    width: 4px;
    // background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    pointer-events: none;
    z-index: 10;
}

.scrollbar-thumb {
    position: absolute;
    width: 100%;
    // background: rgba(90, 104, 255, 0.8);
    background: rgba(255, 255, 255, 0.3);

    border-radius: 2px;
    transition: background 0.2s;
}

.bg-color {
    // background: rgba(255, 255, 255, 0.15);
}

.box-item-container {
    border-radius: 5px;
    padding: 10px 6px;
    line-height: 1.4;
    max-height: 95px;
    overflow: hidden;
    word-wrap: break-word;
    border: 1px solid transparent;

    h3 {
        font-size: 14px !important;
    }
}


.on-active-scene {
    border: 1px solid rgba(255, 255, 255, 0.15);
}

.active-scene {
    border: 1px solid #7284F7;
}

.content-color {
    em {
        color: v-bind('theme.colors.textPrimarySix') !important;
    }
}

.see_all {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
    padding: 2px 11px;
    color: #FFFFFF66;
    font-size: 10px;
    // font-weight: 400;
    font-weight: 500;
}
.message-content-html-popup{
    max-height: 69% !important;
}
.message-content-html {
    max-height: 100px;
    font-size: 16px;
    /* 全局开启换行与断行，处理没有被 <p> 包裹的文本节点 */
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    :deep(p) {
        color: v-bind('theme.colors.textPrimary');
        white-space: pre-wrap;
        /* 保留换行 */
        word-break: break-word;
        /* 长单词断行 */
        overflow-wrap: anywhere;
        /* 连续字符换行 */
        margin: 0;
        /* 与 <br/> 搭配，避免额外间距 */

        font-style: italic;

    }

    img {
        max-width: 100%;
        height: auto;
        display: block;
        border-radius: 6px;
    }



    :deep(em) {
        color: v-bind('theme.colors.textPrimarySix') !important;
    }

    // 🔧 对话和旁白样式
    :deep(.dialogue) {
        // 引号内的对话 - 白色
        color: #fff;
        font-style: normal;

        em {
            color: #fff !important;
            font-style: normal;
        }
    }

    :deep(.narration) {
        // 引号外的旁白 - 灰色
        color: #999;
        opacity: 0.8;
        font-style: italic;
    }

    // 链接样式
    a {
        color: v-bind('theme.colors.primary');
        text-decoration: underline;

        &:hover {
            color: v-bind('theme.colors.primaryHover');
        }

        &:active {
            color: v-bind('theme.colors.primaryActive');
        }
    }

    // 标题样式
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: #fff;
        margin: 8px 0;
        line-height: 1.3;
    }

    // 强调/加粗

    // 行内代码
    code:not(.hljs) {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #fff;
        padding: 2px 6px;
        border-radius: 6px;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }

    // 代码块（已由 highlight.js 样式表控制，这里微调暗色背景适配）
    pre.hljs {
        background: transparent !important;
        border-radius: 10px;
        padding: 12px;
        overflow-x: auto;
        white-space: pre-wrap; // 允许换行并保留缩进
        word-break: break-word; // 遇到长单词或长链接也换行
        overflow-wrap: anywhere; // 进一步保证超长连续字符可换行
    }

    // 使内部 code 继承换行策略
    pre.hljs code {
        white-space: inherit;
        word-break: inherit;
        overflow-wrap: inherit;
        max-width: 100%;
        display: block;
    }

    // 引用
    blockquote {
        border-left: 3px solid v-bind('theme.colors.primary');
        margin: 8px 0;
        padding: 6px 10px;
        background: rgba(255, 255, 255, 0.04);
        color: v-bind('theme.colors.textSecondary');
        border-radius: 6px;
    }

    // 列表
    ul li,
    ol li {
        color: v-bind('theme.colors.textPrimary');
        margin: 4px 0;
    }
}

.scene-preview-popup {
    width: 100vw;
    height: 100vh;
    background: radial-gradient(80% 55% at 50% 12%, rgba(113, 128, 255, 0.26) 0%, rgba(1, 3, 27, 0.96) 52%, #01031b 100%);
}

.scene-preview-content {
    width: 100%;
    height: 100%;
    // padding: 76px 32px 28px;
    padding-top: 64px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.scene-preview-title {
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
}

.scene-preview-message {
    flex: 1;
    color: rgba(255, 255, 255, 0.74);
    font-size: 16px;
    line-height: 1.45;
    display: block;
    -webkit-line-clamp: unset;
    overflow: auto;
    border-top: none;
    padding: 0;
}

.scene-preview-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
    padding-bottom: env(safe-area-inset-bottom, 0);
    position: absolute;
    width: 100%;
    bottom: 40px;
}

.scene-select-btn {
    width: 100%;
    height: 45px;
    border-radius: 23px;
    border: none;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    background: linear-gradient(180deg, #95a5ff 0%, #5a68ff 100%);
    margin-top: 30px;
}

.scene-close-btn {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
